import { MainPage } from '../pages/main-page';

export const getPageNameByType = (type: string | undefined) => {
    switch (type) {
        case 'admin-portal':
            return 'EDITOR';
        case 'backpack':
            return 'BACKPACK';
        case 'folder':
            return 'BACKPACK';
        case 'discover':
            return 'DISCOVER';
        default:
            return 'ACCOUNT';
    }
};

export function getMainPage() {
    return document.querySelector('main-page') as MainPage;
}

